/**
 *
 * @param {Place} place
 * @returns {boolean}
*/

export function checkIntegrationInPlace(place) {
    return place?.order_processing_type === false;
}